import {SortDirection} from "../../data-structures/sort"

export default class ArrayUtils {

    static indexOrder = (array:any[], id:any) => {
        const index = _.indexOf(array, id);
        return index === -1 ? undefined : index;
    }

    static checkIsArray = (o:any) => {
        return Object.prototype.toString.call(o) === '[object Array]';
    }

    static toggleArrayValue = (arr:any[], value:any, options?:any) => {
        let newArr = arr.slice();
        if (newArr.includes(value)) newArr.remove(value);
        else newArr.push(value);

        if (options && options.mandatorySelection && newArr.length === 0) newArr = arr.slice();

        return newArr;
    }

    static toggleArrayObject = (arr:any[], object:any, searchFunc:any, options?:any) => {
        let newArr = arr.slice()
        const found = newArr.find(searchFunc)
        if (found) newArr.remove(found)
        else newArr.push(object)

        if (options && options.mandatorySelection && newArr.length === 0) newArr = arr.slice()

        return newArr
    }

    static addArrayObject = (arr:any[], object:any, searchFunc:any, options?:any) => {
        let newArr = arr.slice()
        const found = newArr.find(searchFunc)
        if (!found) newArr.push(object)

        return newArr
    }

    static removeArrayObject = (arr:any[], object:any, searchFunc:any, options?:any) => {
        let newArr = arr.slice()
        const found = newArr.find(searchFunc)
        if (found) newArr.remove(found)

        if (options && options.mandatorySelection && newArr.length === 0) newArr = arr.slice()

        return newArr
    }

    static replaceArrayObject = (arr:any[], object:any, searchFunc:any, options?:any) => {
        let newArr = arr.slice()
        const index = _.findIndex(newArr, searchFunc)

        if (index) {
            // replace object at index
            newArr.splice(index, 1, object);
        }

        return newArr
    }

    static addValueToArray = (array:any[], value:any) => {
        let newArray = array ? array.slice() : []
        if (value && !newArray.includes(value)) {
            newArray.push(value);
        }

        return newArray;
    }

    static removeValueFromArray = (array:any[], value:any) => {
        let newArray = array ? array.slice() : []
        const index = newArray.indexOf(value);
        if (index !== -1) {
            newArray.splice(index, 1);
        }

        return newArray;
    }

    static moveInArrayMutate = (array:any[], from:number, to:number) => {
        const startIndex = from < 0 ? array.length + from : from;

        if (startIndex >= 0 && startIndex < array.length) {
            const endIndex = to < 0 ? array.length + to : to;

            const [item] = array.splice(from, 1);
            array.splice(endIndex, 0, item);
        }
    }

    static moveInArray = (array:any[], from:number, to:number) => {
        array = [...array];
        ArrayUtils.moveInArrayMutate(array, from, to);
        return array;
    }

    static mergeNumberRanges(ranges:number[][]) {
        const result: number[][] = []
        let previous: number[]

        ranges.forEach((range: number[]) => {
            if (!previous || range[0] > previous[1])
                result.push(previous = range)
            else if (range[1] > previous[1])
                previous[1] = range[1]
        })

        return result
    }

    static invertNumberRanges(arrOfRanges : number[][], maxValue    : number = 100000): number[][] | null {
        if (!Array.isArray(arrOfRanges) ||
            !_.filter(arrOfRanges,(range) => Array.isArray(range) && range[0] !== range[1]).length) {
            return [[0, maxValue]]
        }

        let prep: number[][]
        prep = _.filter(arrOfRanges, (rangeArr) => rangeArr[0] !== rangeArr[1])

        let res: number[][] = (prep as any[]).reduce((accum, currArr, i, arr) => {
            let res2 = []

            // if the first range's first index is not zero, additionally add zero range:
            if (i === 0 && arr[0][0] !== 0) {
                res2.push([0, arr[0][0]])
            }

            // Now, for every range, add inverted range that follows. For example,
            // if we've got [[1, 2], [4, 5]] and we're processing [1, 2], then
            // add the inverted chunk that follows it, [2, 4].
            let endingIndex = i < arr.length - 1 ? arr[i + 1][0] : maxValue
            if (currArr[1] !== endingIndex) {
                res2.push([currArr[1], endingIndex])
            }

            return (accum as any[]).concat(res2 as any[])
        }, []) as any[]

        return res as number[][]
    }

    // utility function to compute the median from a numeric array
    static calculateMedianNumber(arr: number[]): number | undefined {

        const len = arr.length
        if (len === 0) {
            // no values to calculate median from
            return undefined
        }

        // sort the input array in ascending order
        const values = _.orderBy(arr, (value: number) => value, SortDirection.ASC)

        // determine the middle index of the array
        const mid = Math.floor(len / 2)

        if (len % 2 === 0) {
            // even: median is average of middle two elements
            return (values[mid - 1] + values[mid]) / 2
        } else {
            // odd: median is the middle value
            return values[mid]
        }
    }
}